import { FC, memo, useMemo } from 'react';
import { IButtonProps } from './types';

export const Button: FC<IButtonProps> = memo(
  ({
    text,
    icon,
    styleProp,
    textStyleProps,
    disabled = false,
    styleType = 'primary',
    iconPosition = 'left',
    ...restProps
  }) => {
    const [btnStyle, textStyle] = useMemo((): [string, string] => {
      if (styleType === 'primary') return ['bg-primary', 'text-white'];
      if (styleType === 'secondary') return ['bg-[#F3F5FC] border-[#4140421A]', 'text-primary'];
      if (styleType === 'delete') return ['bg-[#EC3E3E1A] border-transparent', 'text-error'];
      return ['', ''];
    }, [styleType]);
    return (
      <button
        {...restProps}
        className={`w-full rounded-[12px] py-[14px] flex-centred ${btnStyle} ${styleProp} ${
          disabled && 'opacity-40 cursor-auto '
        }`}
        type="button"
        disabled={disabled}
      >
        {iconPosition === 'left' && icon}
        <p className={`text-[13px] leading-[20px]  ${textStyle} ${textStyleProps}`}>{text}</p>
        {iconPosition === 'right' && icon}
      </button>
    );
  }
);
